/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
    }
    onClickHandler(event) {
      event.preventDefault();
      // `index` is only the line's POSITION in the cart and goes stale the
      // moment anything reorders the cart behind us (a free-gift app adding or
      // dropping its line, a second tab, a discount app). `key` is the line
      // item's own id and always points at this line — pass it through so the
      // change request can target it directly. `index` is still carried for
      // the row-level loading state, which is addressed by position.
      const index = this.dataset.index;
      const key = this.dataset.key;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0', key);
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index, key } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
